export var FeatureToggleType;
(function (FeatureToggleType) {
    FeatureToggleType["VIDEO_CALL"] = "videoCall";
    FeatureToggleType["ANAMNESIS"] = "anamnesis";
    FeatureToggleType["SHOP"] = "shop";
    /**
     * Patient self-service Terminübersicht (PRD #1330 / TM-9436). Gates the
     * patient-facing appointment overview route, its menu entry, and the
     * cancel/reschedule/request actions built on top of it. Unlike the three
     * toggles above it defaults OFF — handing patients a cancel button is a
     * per-practice decision, not a release side-effect.
     */
    FeatureToggleType["PATIENT_APPOINTMENTS"] = "patientAppointments";
    /**
     * Patient self-booking (PRD #1343). Gates the entire slot-finder-backed
     * booking + reschedule flow — the plan cards, the slot grid, the patient
     * slot-search endpoint and hold creation — separately from
     * {@link PATIENT_APPOINTMENTS} so a practice can adopt the passive overview
     * first and switch on booking later. Defaults OFF, same as the overview
     * toggle: letting patients place holds is an explicit per-practice decision.
     */
    FeatureToggleType["PATIENT_BOOKING"] = "patientBooking";
})(FeatureToggleType || (FeatureToggleType = {}));
//# sourceMappingURL=feature-toggle-type.enum.js.map